
import 'core-js/es/map';
import 'core-js/es/set';
import 'raf/polyfill';


import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './ie.css';



import App from './App';
// import registerServiceWorker from './registerServiceWorker';
import { BrowserRouter } from 'react-router-dom'

import "./fonts/fonts.css";

window.matchMedia = window.matchMedia || (() => { return { matches: false, addListener: () => {}, removeListener: () => {}, }; });
// const browserHistory = {};
const basename = "/";
// const basename = "/city2/";
// const basename = "/";
// const basename = "/go-israel-new/v1/";

const getParameterByName = function (name) {
      name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
      var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
          results = regex.exec(window.location.search);
      return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
};



var currentLang = localStorage.getItem('currentLang') != null  ? localStorage.getItem('currentLang') : 'uk';
var langsArray = [
	'uk',
	'cz',
	'ro',
	'dk',
	'se',
	'hu',
	'nl',
];

// alert(currentLang);

var l = getParameterByName('lang');

/// check to see if  in array
if ( l != '' && langsArray.indexOf(l) !== -1 ) {
	currentLang = l;
}

localStorage.setItem('currentLang' , currentLang);


if ( localStorage.getItem('currentLang') != null ) {
	l =  localStorage.getItem('currentLang');
}

ReactDOM.render(
	<BrowserRouter basename={basename}   forceRefresh={true} >
		
		<App />
	</BrowserRouter>
	, document.getElementById('root'));
// registerServiceWorker();






// WEBPACK FOOTER //
// ./src/index.js